export const TRAVEL_DISTANCE_OPTIONS = [
  {
    value: 'near',
    title: 'Around the Corner',
    description: '5-10 minutes driving',
  },
  {
    value: 'medium',
    title: 'Within Easy Reach',
    description: '10-30 minutes driving',
  },
  {
    value: 'far',
    title: 'Maximize Your Potential',
    description: '45+ minutes driving',
  },
];

export const normalizeInstructorClassTypes = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (!value) return [];

  return String(value)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
};

export const normalizeInstructorCustomClassTypes = (value, nowMs = Date.now()) => {
  const items = Array.isArray(value)
    ? value
    : String(value || '').split(',');
  const seen = new Set();

  return items.reduce((customClassTypes, item) => {
    const classType = String(item?.value || item || '')
      .trim()
      .replace(/\s+/g, ' ');
    const key = classType.toLowerCase();

    if (!classType || seen.has(key)) return customClassTypes;

    seen.add(key);
    customClassTypes.push({
      value: classType,
      source: 'user_entered',
      createdAt: Number(item?.createdAt) || nowMs,
    });

    return customClassTypes;
  }, []);
};

export const getInstructorProfileBadges = ({
  assignedClassCount = 0,
  completedClassCount = 0,
} = {}) => {
  const badges = [];

  if (assignedClassCount === 0) {
    badges.push({
      title: 'New Instructor!',
      description: 'We are excited to have you here. Claim a class in your area to start your Fit Group journey.',
      colorScheme: 'blue',
    });
    return badges;
  }

  if (completedClassCount > 0) {
    badges.push({
      title: 'Class Completion Champion',
      description: 'You completed your class form and helped keep payouts moving.',
      colorScheme: 'green',
    });
  }

  if (assignedClassCount <= 5) {
    badges.push({
      title: 'Rising Star',
      description: 'You are building momentum with Fit Group USA.',
      colorScheme: 'purple',
    });
  } else if (assignedClassCount <= 15) {
    badges.push({
      title: 'Fit Group USA Champion',
      description: 'You are becoming a familiar face for our facilities.',
      colorScheme: 'orange',
    });
  } else {
    badges.push({
      title: 'Fit Group USA All Star',
      description: 'You are a go-to instructor across the Fit Group network.',
      colorScheme: 'yellow',
    });
  }

  return badges;
};
